import { z } from "zod";

export const loginFormSchema = z.object({
	username: z.string().trim().nonempty("login.errors.username.empty"),
	password: z.string().trim().min(6, "login.error.password.min"),
});

export type LoginFormFields = z.output<typeof loginFormSchema>;

export const authUserSchema = z.object({
	id: z.string().optional(),
	shortName: z.string().optional(),
	permissions: z.array(z.string()).default([]),
	role: z.object({
		slug: z.string(),
		permissions: z.array(z.string()).default([]),
		options: z
			.object({
				homepage: z.string().optional(),
			})
			.optional(),
	}),
	personId: z.string().optional(),
});

export type AuthUser = z.infer<typeof authUserSchema>;

export const authSessionSchema = z.object({
	token: z.string(),
	user: authUserSchema,
});

export type AuthSession = z.output<typeof authSessionSchema>;
